import { groupBy } from "lodash";
import * as React from "react";
import { ContextStore } from "../../../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../../../Wrap/Constants/Enums/ContextType";
import { SubAccountType } from "../../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { TransferStatus } from "../../../../../../../../../Wrap/Constants/Enums/Transfer/TransferStatus";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Permission } from "../../../../../../../../Shared/Permission/Permission";
import { Navigator } from "../../../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../../../Urls";
import { TransactionEnum } from "../../../Transactions/Resource/Contents";
import { ProductOverviewPaymentsInAction } from "../../Action/ProductOverviewPaymentsInAction";
import { IsaAllowanceOverview } from "../IsaAllowanceOverview";
import { ActiveInstructions } from "./ActiveInstructions";
import { CompletedInstructions } from "./CompletedInstructions";
import { Transfers } from "./Transfers";

interface IProductOverviewPaymentsInProps {
    selectedProduct?: SubAccountType;
    subAccountHierarchyId: string;
    headaccount: ClientAccount;
}

export const ProductOverviewPaymentsIn = (props: IProductOverviewPaymentsInProps) => {
    const [activeTransferIn, setActiveTransferIn] = React.useState([]);
    const [completeTransferIn, setCompleteTransferIn] = React.useState([]);
    React.useEffect(() => {
        ProductOverviewPaymentsInAction.getTransferInDetail(props.subAccountHierarchyId, (data) => {
            setActiveTransferIn([]);
            setCompleteTransferIn([]);
            // group by status
            const groupedData = groupBy(data, "Status");
            Object.keys(groupedData).forEach((key) => {
                if (key === TransferStatus.Pending.toString()) {
                    setActiveTransferIn(groupedData[key]);
                } else if (key === TransferStatus.Completed.toString()) {
                    setCompleteTransferIn(groupedData[key]);
                }
            });
        });
    }, [props.subAccountHierarchyId]);

    return (
        <>
            {props.selectedProduct == SubAccountType.StocksIsa && (
                <IsaAllowanceOverview headaccount={props.headaccount} />
            )}
            <ActiveInstructions
                subAccountHierarchyId={props.subAccountHierarchyId}
                activeTransferIn={activeTransferIn}
                SubaccountType={props.selectedProduct}
                headAccount={props.headaccount}
            />
            <CompletedInstructions
                subAccountHierarchyId={props.subAccountHierarchyId}
                selectedProduct={props.selectedProduct}
            />
            {(props.selectedProduct == SubAccountType.StocksIsa ||
                props.selectedProduct == SubAccountType.InvestmentAccount) && (
                <Transfers completedTransferIn={completeTransferIn} headaccount={props.headaccount} />
            )}

            <Permission userClaim={UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView}>
                <div className="mt-35">
                    <p>
                        To view all payments (including cancelled instructions){" "}
                        <a
                            href="javascript:void(0);"
                            className="hyperlink"
                            onClick={() => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                    }).transactions,
                                    {
                                        scrollAfterNavigating: true,
                                        queryParamsObject: {
                                            transtypeselect: TransactionEnum.paymentsWithdrawals,
                                            hierarchyid: props.subAccountHierarchyId,
                                        },
                                    }
                                );
                            }}
                        >
                            click here.
                        </a>
                    </p>
                </div>
            </Permission>
        </>
    );
};
